export const PLACEHOLDER_NOT_IN_ORDER_LABEL =
    'Placeholder – not included in order total.';
